import Alpine from "alpinejs";
import intersect from "@alpinejs/intersect";
import focus from '@alpinejs/focus'

document.addEventListener("DOMContentLoaded", function () {

  if(window.alpineData) {

    Object.keys(window.alpineData).forEach((key) => {

      Alpine.data(key, window.alpineData[key]);
      console.log('Loaded Alpine Data:', key);
    });
  }

  Alpine.plugin(intersect);
  Alpine.plugin(focus)
  Alpine.start();
  window.Alpine = Alpine;
});
